/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../../styles/components/pageComponents/dashboard/guest/IcomResources.module.css';
import BlogCover from '../../../../assets/images/BlogCover.png';

interface ResourceCard {
	id: number;
	title: string;
	description: string;
	link: string;
}

const IOCMResources: React.FC = () => {
	const tabs = [
		'Blog Articles',
		'Case Studies',
		'Whitepapers',
		'Trends & Research',
		'Downloads',
	];

	const resourceData: ResourceCard[] = [
		{
			id: 1,
			title: 'Collaboration in a Competitive World: How does the army make it happen?',
			description:
				'Lorem ipsum dolor sit amet consectetur. Nisi malesuada metus scelerisque lacus nisl laoreet porttitor in. Volutpat est vitae netus arcu sed eget ut eget.',
			link: 'https://ioc-m.com/resources/#blog',
		},
		{
			id: 2,
			title: 'Time for a Radical Rethink of Middle Management?',
			description:
				'Lorem ipsum dolor sit amet consectetur. Nisi malesuada metus scelerisque lacus nisl laoreet porttitor in. Volutpat est vitae netus arcu sed eget ut eget.',
			link: 'https://ioc-m.com/resources/#blog',
		},
		{
			id: 3,
			title: 'Before You Enrol: The Real Reasons to Pursue a Coaching Certification',
			description:
				'Lorem ipsum dolor sit amet consectetur. Nisi malesuada metus scelerisque lacus nisl laoreet porttitor in. Volutpat est vitae netus arcu sed eget ut eget.',
			link: 'https://ioc-m.com/resources/#blog',
		},
	];

	const handleCardClick = () => {
		window.location.href = 'https://ioc-m.com/resources/#blog';
	};

	return (
		<section className={styles.resourceSection}>
			<h2 className={styles.sectionTitle}>IOCM RESOURCES</h2>

			<div className={styles.resourceCardContainer}>
				{/* Tab Navigation */}
				<div className={styles.tabList}>
					{tabs.map(tab => (
						<button
							key={tab}
							type="button"
							className={styles.tabButton}
							disabled
						>
							{tab}
						</button>
					))}
				</div>

				{/* Resource Grid */}
				<div className={styles.grid}>
					{resourceData.map(item => (
						<div
							key={item.id}
							className={styles.card}
							onClick={handleCardClick}
							role="link"
							tabIndex={0}
							onKeyDown={e => {
								if (e.key === 'Enter' || e.key === ' ') {
									handleCardClick();
								}
							}}
						>
							<div className={styles.imageWrapper}>
								<img
									src={BlogCover}
									alt={item.title}
									className={styles.cardImage}
								/>
							</div>

							<div className={styles.cardContent}>
								<div className={styles.titleHeader}>
									<h3 className={styles.cardTitle}>
										{item.title}
									</h3>

									<a
										href={item.link}
										className={styles.externalLinkIcon}
										onClick={e => e.stopPropagation()}
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth="2"
										>
											<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3" />
										</svg>
									</a>
								</div>

								<p className={styles.cardDescription}>
									{item.description}
								</p>
							</div>
						</div>
					))}
				</div>

				{/* Pagination */}
				<div className={styles.pagination}>
					{[1, 2, 3, 4, 5].map(num => (
						<button
							key={num}
							type="button"
							className={`${styles.pageBtn} ${
								num === 1 ? styles.activePage : ''
							}`}
							disabled
						>
							{num}
						</button>
					))}
				</div>
			</div>
		</section>
	);
};

export default IOCMResources;